<template>
  <div style="cursor: pointer">
    <apexchart
      height="100%"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import IndicadoresAPI from "../../../api/indicadores";
import { options } from "./Opcoes";

export default {
  props: {
    tela_compra: {
      type: Boolean,
      default: false,
    },
    filtros: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    options: options,
    series: [],
  }),
  mounted() {
    this.montarGrafico();
  },
  watch: {
    filtros: {
      handler: function () {
        this.montarGrafico();
      },
    },
  },
  methods: {
    limpaDadosGrafico() {
      this.series = [
        {
          name: "Rupturas por COMPRA",
          color: "rgba(214, 14, 43, 1)",
          data: []
        },
        {
          name: "Rupturas por DRP",
          color: "#FFBF00",
          data: []
        }
      ]
    },
    montarGrafico() {
      this.limpaDadosGrafico();

      clearTimeout(this.interval);

      this.interval = setTimeout(() => {

        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          ...this.filtros
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          IndicadoresAPI.getDadosPerdaVendaRupturaGrafico(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              let labels = []
              const { rupturas } = response.data;

              if (this.tela_compra) {
                rupturas.referencias.forEach(item => {
                  const [mes, ano] = item.split('/')
                  labels.push(`${this.Helpers.nomeMeses[Number(mes) - 1].substring(0,3)}/${String(ano).substring(2,4)}`)
                })
              } else {
                rupturas.referencias.forEach(item => {
                  const anoMes = item.split('/')
                  labels.push(`${this.Helpers.nomeMeses[anoMes[0] - 1].substring(0,3)} ${anoMes[1]}`)
                })
              }

              this.options = {
                labels: labels,
              };

              this.series = [
                {
                  name: "Rupturas por COMPRA",
                  color: "rgba(214, 14, 43, 1)",
                  data: rupturas.tipos.COMPRA
                },
                {
                  name: "Rupturas por DRP",
                  color: "#FFBF00",
                  data: rupturas.tipos.DRP
                }
              ];
            })
        );
      }, 700);
    },
  },
};
</script>
